<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Badge
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <h2>Use Case 1: Medium</h2>
  <maced-badge badgeId="badgeId" [label]="badge1" [labelText]="notification" ariaLabel="Ninty" size="medium" color="red"></maced-badge>

  <h2>Use Case 2: Small</h2>
  <maced-badge badgeId="badgeId2" [label]="badge2" [labelText]="notification" ariaLabel="One Hundred and Two" size="small" color="red"></maced-badge>

  <h2>Use Case 3: Dot</h2>
  <maced-badge badgeId="badgeId3" [label]="badge1" [labelText]="notification" ariaLabel="Ninty" size="dot"></maced-badge>

  <h2>Use Case 4: Gray Medium</h2>
  <maced-badge badgeId="badgeId4" [label]="badge1" [labelText]="notification" ariaLabel="Ninty" size="medium" color="gray"></maced-badge>

  <h2>Use Case 5: Gray Small</h2>
  <maced-badge badgeId="badgeId5" [label]="badge2" [labelText]="notification" ariaLabel="One Hundred and Two" size="small" color="gray"></maced-badge>

</div>